import RecordingsRepository from "./recordingsRepository";

const repositories = {
    recordings: RecordingsRepository
};

export const RepositoryFactory = {
    get: (name) => repositories[name]
};
